import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SelectDialogConfig, SelectDialogOption } from '@shared/components/select-dialog/select-dialog-config';
import { NonNullableFormBuilder, Validators } from '@angular/forms';
import { I18nService } from '@shared/i18n';

@Component({
  selector: 'app-select-dialog',
  templateUrl: './select-dialog.component.html',
  styleUrls: ['./select-dialog.component.scss'],
  standalone: false,
})
export class SelectDialogComponent<T = any> {
  protected readonly i18n = inject(I18nService);
  private dialogRef = inject<MatDialogRef<SelectDialogConfig<T>>>(MatDialogRef);
  private readonly data = inject<SelectDialogConfig<T>>(MAT_DIALOG_DATA);
  private readonly fb = inject(NonNullableFormBuilder);

  public readonly title: string;
  public readonly content: string[];
  public readonly options: SelectDialogOption<T>[];
  public readonly cancelText: string;
  public readonly confirmText: string;

  public readonly form = this.fb.group({
    select: [this.data.initialValue, [Validators.required]],
  });
  public get select() {
    return this.form.controls.select;
  }

  constructor() {
    const data = this.data;

    this.title = data.title;
    this.content = data.content;
    this.options = data.options;
    this.cancelText = data.cancel;
    this.confirmText = data.confirm;
  }

  public cancel() {
    this.dialogRef.close({ confirmed: false });
  }

  public confirm() {
    this.dialogRef.close({ confirmed: true, value: this.select.value });
  }
}
